import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import RouterLink from 'components/sharedComponents/RouterLink'
import { mediaQueries } from 'plugins/device'
import {
  colors,
  IconBellMulticolor,
  IconCoinsMulticolor,
  IconEditMulticolor,
  IconFavoriteMulticolor,
  IconIllustrativeOk,
  IconIllustrativeRecommendation,
  IconLeafMulticolor,
  IconSettingsMulticolor,
  TextBody,
  TextSubHeading,
} from '@blocket/blocket-ui'
import { useSelector } from 'react-redux'

const MyBlocketCard = styled.div`
  background: ${colors.grey100};
  padding: 16px;
  word-break: break-word;
  border-radius: 6px;
  height: 100px;
  @media ${mediaQueries.large} {
    grid-template-columns: repeat(3, 1fr);
  }
  @media ${mediaQueries.medium} {
    height: 136px;
  }
`

const MyBlocketCardText = styled(TextSubHeading)`
  font-size: 15px;
  line-height: 20px;
  margin-top: 4px;
  @media ${mediaQueries.medium} {
    font-size: 17px;
    line-height: 26px;
    margin-top: 0px;
  }
`

const Cards = ({ device }) => {
  const isLargeScreen = device.is('medium')

  // Previously an unleash toggle
  const transactionLogsEnabled = true

  const { recommendedAdsWebEntrypoint } = useSelector((state) => state.optimizely.features)
  const enableRecommendedAds = recommendedAdsWebEntrypoint?.enabled ?? true

  const myBlocketCardsData = [
    {
      icon: IconEditMulticolor,
      title: 'Mina annonser',
      description: 'Se och hantera dina egna annonser',
      link: '/mina-annonser',
      externalLink: true,
    },
    {
      icon: IconFavoriteMulticolor,
      title: 'Sparade annonser',
      description: 'Annonser du valt att spara',
      link: '/sparade/annonser',
      externalLink: true,
    },
    {
      icon: IconIllustrativeRecommendation,
      title: 'Utvalt för dig',
      description: 'Se annonser som är anpassade för just dig och dina preferenser.',
      link: '/rekommenderade-annonser',
      externalLink: true,
    },
    {
      icon: IconBellMulticolor,
      title: 'Bevakningar',
      description: 'Nya annonser från dina bevakningar',
      link: '/sparade',
      externalLink: true,
    },
    {
      icon: IconCoinsMulticolor,
      title: 'Sålt med våra säkra tjänster',
      description: 'Allt du sålt med våra frakt- och betalningstjänster',
      link: '/mina-forsaljningar',
      externalLink: false,
    },
    {
      icon: IconIllustrativeOk,
      title: 'Köpt med våra säkra tjänster',
      description: 'Allt du köpt med våra frakt- och betalningstjänster',
      link: '/mina-kop',
      externalLink: false,
    },
    {
      icon: IconLeafMulticolor,
      title: 'Mitt miljöbidrag',
      description: 'Se vad du besparat miljön via Blocket',
      link: '/mitt-miljobidrag',
      externalLink: false,
    },
    {
      icon: IconSettingsMulticolor,
      title: 'Kontoinställningar',
      description: 'Se och hantera din profil',
      link: '/konto',
      externalLink: false,
    },
  ]

  return myBlocketCardsData.map((data) => {
    const transactionLogs = data.title === 'Köpt på Blocket' || data.title === 'Sålt på Blocket'
    const hideRecommendations = data.title === 'Utvalt för dig' && !enableRecommendedAds

    if (hideRecommendations) {
      return null
    }

    if (!transactionLogs || (transactionLogs && transactionLogsEnabled)) {
      const Card = () => {
        return (
          <MyBlocketCard data-cy={`link-to-${data.link}`}>
            <data.icon />
            <MyBlocketCardText tagName="h3">{data.title}</MyBlocketCardText>
            {isLargeScreen && <TextBody>{data.description}</TextBody>}
          </MyBlocketCard>
        )
      }
      if (data.externalLink) {
        return (
          <a href={data.link} key={data.link}>
            <Card />
          </a>
        )
      }
      return (
        <RouterLink key={data.link} href={data.link}>
          <Card />
        </RouterLink>
      )
    }
    return null
  })
}

Cards.propTypes = {
  device: PropTypes.object.isRequired,
}

export default Cards
